import { UrlFirstSegment } from 'utils/global';
import { serviceType } from 'utils/constants';
import { loadable } from 'react-lazily/loadable';
import { lazy, Suspense } from 'react';
const Button = lazy(() => import('components/buttons/Button'));
const { TranslationImage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { TranslationMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { HighlightedMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});

interface Props {
	content: {
		[key: string]: any;
	};
	layoutType?: string;
}

const HelpLayout = ({ layoutType, content }: Props) => {
	const urlFirstSegment = UrlFirstSegment();

	const renderClass = () => {
		if (layoutType) {
			return layoutType;
		} else {
			if (urlFirstSegment === serviceType.INDIVIDUAL) {
				return 'layout1';
			} else if (urlFirstSegment === serviceType.NABIL || urlFirstSegment === serviceType.HOME) {
				return 'layout1';
			} else if (urlFirstSegment === serviceType.BUSINESS) {
				return 'layout2';
			} else if (urlFirstSegment === serviceType.SERVICESANDPAYMENTS) {
				return 'layout3';
			}
		}
	};

	const highlightedTextClass = renderClass() === 'layout2' ? 'text-success' : 'text-success';

	return (
		<section className={`py-5 promosection-one ${renderClass()}`}>
			<div className="container">
				<div className="row align-items-center pb-3 pb-md-0">
					<div className="col-md-7 order-1 order-md-0">
						<h2 className="font-weight-bold text-danger mb-3">
							<HighlightedMessage data={content} value="text" className={highlightedTextClass} />
						</h2>
						<h5 className=" text-d-gray mb-3">
							<TranslationMessage data={content} value="subtext" />
						</h5>

						<div className="d-flex flex-column flex-sm-row">
							<Suspense fallback={<div>Loading...</div>}>
								<Button buttonStyle="btn-gradient--solid" buttonSize="btn--medium" icon type="button" url={content.button_url}>
									<TranslationMessage data={content} value="button_text" />
								</Button>
							</Suspense>

							<div className="mr-3 mb-2"></div>
							<Suspense fallback={<div>Loading...</div>}>
								<Button buttonStyle="btn-success--outline" buttonSize="btn--medium" icon type="button" url={content.second_button_url}>
									<TranslationMessage data={content} value="second_button_text" />
								</Button>
							</Suspense>
						</div>
					</div>
					<div className="col-md-5 order-0 order-md-1">
						<TranslationImage data={content} value="image" className="img-fluid" />
					</div>
				</div>
			</div>
		</section>
	);
};

export { HelpLayout };
